/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { ButtonGroup, Card, Col, InputGroup, Row } from "react-bootstrap"
import DatePicker from "react-multi-date-picker"
import InputIcon from "react-multi-date-picker/components/input_icon"
import { useNavigate } from "react-router-dom"
import { Button, Input, Table } from "../../../components"
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks/Hook"
import { AllBookedCourtsList, setCourtColumn } from "../../../redux/Slice/CourtBooking/CourtBookingListSlice"
import BootstrapSelect from "react-bootstrap-select-dropdown";
import { FilterModal } from "./FilterModal"
import { DownloadCourtBookingReport } from "../../../utilities/api/courtBooking"
import { toast } from "react-toastify"
import { DownloadModal } from "./DownloadModal"

const ListOfCourtsBooking = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { AllBookedCourtsData, currentPage, rowsPerPage, totalPage, totalRows, courtColumns, errorMessage } = useAppSelector(state => state.bookedCourt)
    const { SelectedFacility } = useAppSelector(state => state.facilityList)
    const [key, setKey] = useState("")
    const [fromDate, setFromDate] = useState("")
    const [toDate, setToDate] = useState("")
    const [facilityId, setFacilityId] = useState<any>(SelectedFacility || "")
    const [sportName, setSportName] = useState("")
    const [courtName, setCourtName] = useState("")
    const [bookingType, setBookingType] = useState("")
    const [bookingStatus, setBookingStatus] = useState("")
    const [paymentStatus, setPaymentStatus] = useState("")
    const [paymentMode, setPaymentMode] = useState("")
    const [paymentMethod] = useState("")
    const [show, setShow] = useState(false);
    const [sorting, setSorting] = useState({ column: "", order: "" });
    const [downloadModalOpen, setDownloadModalOpen] = useState(false)
    const [isMounted, setIsMounted] = useState(false)


    const orderColComing = ["fullName", "bookingDate", "startDate", "endDate", "facilityName", "sportName", "courtName", "status", "paymentStatus"]
    const orderColSend = ["firstName", "createdAt", "startDate", "endDate", "facility", "sport", "court", "status", "paymentStatus"]

    const orderByColumn = (col: string) => {
        if (orderColComing.includes(col)) return orderColSend[orderColComing.indexOf(col)]
        else return ""
    }
    const orderCol = orderByColumn(sorting.column)

    const convertDate = (date: string) => date?.split("-").reverse().join("-") ? date?.split("-").reverse().join("-") : ""

    useEffect(() => {
        if (key.length <= 0) dispatch(AllBookedCourtsList({ page: "1", key: "", fromDate: convertDate(fromDate), toDate: convertDate(toDate), facilityId: facilityId, sportName: sportName, courtName: courtName, bookingType: bookingType, bookingStatus: bookingStatus, paymentStatus: paymentStatus, paymentMode: paymentMode, paymentMethod: paymentMethod, orderByCol: "", orderBy: "" }))
    }, [key])

    if (errorMessage) {
        toast.error(errorMessage.message)
    }

    const handleAdd = () => {
        navigate("/add-court-booking")
    }

    const handleUserInfo = (id: any) => {
        navigate("/court-booking-details", { state: id })
    }

    const NextPage = (nextpage: number) => {
        dispatch(AllBookedCourtsList({ page: nextpage, key: key, fromDate: convertDate(fromDate), toDate: convertDate(toDate), facilityId: facilityId, sportName: sportName, courtName: courtName, bookingType: bookingType, bookingStatus: bookingStatus, paymentStatus: paymentStatus, paymentMode: paymentMode, paymentMethod: paymentMethod, orderByCol: orderCol, orderBy: sorting.order }))
    }

    const PreviousPage = (prevpage: number) => {
        dispatch(AllBookedCourtsList({ page: prevpage, key: key, fromDate: convertDate(fromDate), toDate: convertDate(toDate), facilityId: facilityId, sportName: sportName, courtName: courtName, bookingType: bookingType, bookingStatus: bookingStatus, paymentStatus: paymentStatus, paymentMode: paymentMode, paymentMethod: paymentMethod, orderByCol: orderCol, orderBy: sorting.order }))
    }

    const handleSearch = () => {
        dispatch(AllBookedCourtsList({ page: "1", key: key, fromDate: convertDate(fromDate), toDate: convertDate(toDate), facilityId: facilityId, sportName: sportName, courtName: courtName, bookingType: bookingType, bookingStatus: bookingStatus, paymentStatus: paymentStatus, paymentMode: paymentMode, paymentMethod: paymentMethod, orderByCol: "", orderBy: "" }))
    }

    const handleFromDate = (e: any) => {
        setFromDate(e?.format("DD-MM-YYYY"))
    }

    const handleToDate = (e: any) => {
        setToDate(e?.format("DD-MM-YYYY"))
    }

    const handleSearchByDate = () => {
        dispatch(AllBookedCourtsList({ page: "1", key: key, fromDate: convertDate(fromDate), toDate: convertDate(toDate), facilityId: facilityId, sportName: sportName, courtName: courtName, bookingType: bookingType, bookingStatus: bookingStatus, paymentStatus: paymentStatus, paymentMode: paymentMode, paymentMethod: paymentMethod, orderByCol: "", orderBy: "" }))
    }

    useEffect(() => {
        setFacilityId(SelectedFacility)
        if (isMounted) {
            dispatch(AllBookedCourtsList({ page: "1", key: key, fromDate: convertDate(fromDate), toDate: convertDate(toDate), facilityId: SelectedFacility ? SelectedFacility : "", sportName: sportName, courtName: courtName, bookingType: bookingType, bookingStatus: bookingStatus, paymentStatus: paymentStatus, paymentMode: paymentMode, paymentMethod: paymentMethod, orderByCol: "", orderBy: "" }))
        } else {
            setIsMounted(true)
        }
    }, [SelectedFacility])

    const handleFilterSubmit = () => {
        dispatch(AllBookedCourtsList({ page: "1", key: key, fromDate: convertDate(fromDate), toDate: convertDate(toDate), facilityId: SelectedFacility ? SelectedFacility : "", sportName: sportName, courtName: courtName, bookingType: bookingType, bookingStatus: bookingStatus, paymentStatus: paymentStatus, paymentMode: paymentMode, paymentMethod: paymentMethod, orderByCol: "", orderBy: "" }))
        setShow(false)
    }

    useEffect(() => {
        if (isMounted) {
            dispatch(AllBookedCourtsList({ page: "1", key: key, fromDate: convertDate(fromDate), toDate: convertDate(toDate), facilityId: SelectedFacility ? SelectedFacility : "", sportName: sportName, courtName: courtName, bookingType: bookingType, bookingStatus: bookingStatus, paymentStatus: paymentStatus, paymentMode: paymentMode, paymentMethod: paymentMethod, orderByCol: orderCol, orderBy: sorting.order }))
        } else {
            setIsMounted(true)
        }
    }, [sorting])

    const ColValue = ['Customer Name', 'Contact Number', 'Booking Type', 'Company Name', 'Booking Date', 'Start Date', 'End Date', 'Booking Status', 'Facility Name', 'Court Name', 'Sport Name', 'Payment Mode', 'Payment Method', 'Payment Status', 'Amount']
    const ColLabelKey = ['fullName', 'phone', 'bookingType', 'companyName', 'bookingDate', 'startDate', 'endDate', 'status', 'facilityName', 'courtName', 'sportName', 'paymentMode', 'paymentMethod', 'paymentStatus', 'totalAmount']
    const AllColumn = ColValue.map((item, index) => (
        {
            value: item,
            labelKey: ColLabelKey[index],
        }
    ))


    const defaultColumn = [...courtColumns].map((item => item.accessor))

    const handleChange = (value: any) => {
        const col = value.selectedValue.map((item: string, index: number) => {
            return {
                Header: item,
                accessor: value.selectedKey[index],
            }
        })
        dispatch(setCourtColumn(col))
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleClear = () => {
        setKey("");
        setFromDate("");
        setToDate("");
        setSportName("");
        setCourtName("")
        setBookingType("")
        setBookingStatus("")
        setPaymentStatus("")
        setPaymentMode("")
        setSorting({ column: "", order: "" });
        dispatch(AllBookedCourtsList({ page: "1", key: "", fromDate: "", toDate: "", facilityId: SelectedFacility, sportName: "", courtName: "", bookingType: "", bookingStatus: "", paymentStatus: "", paymentMode: "", paymentMethod: "", orderByCol: "", orderBy: "" }))
    };

    const handleDownload = async () => {
        const result = await DownloadCourtBookingReport({ key: key, fromDate: convertDate(fromDate), toDate: convertDate(toDate), facilityId: SelectedFacility, sportName: sportName, courtName: courtName, bookingType: bookingType, bookingStatus: bookingStatus, paymentStatus: paymentStatus, paymentMode: paymentMode, paymentMethod: paymentMethod, orderByCol: orderCol, orderBy: sorting.order })
        if (result.statusCode === 200) {
            setDownloadModalOpen(false)
            const url = result.data.fileUrl
            const link = document.createElement('a');
            link.href = url;
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        } else {
            toast.error(result.response.data.message)
        }
    }

    return (
        <>
            <Card>
                <Card.Body className="pb-0">

                    <div className="page-title align-items-center d-flex justify-content-between">
                        <Card.Title className="mb-0">Courts Booking List</Card.Title>
                        <ButtonGroup>
                            <Button type="button" bname="Filter" onClick={handleShow} className="btn btn-light me-2 rounded-1 text-dark text-info fitler-img" id="filter" name="filter"></Button>
                            {AllBookedCourtsData.length !== 0 && <Button onClick={() => setDownloadModalOpen(true)} type="button" bname="Download Reports" name="download-reports" id="download-reports" className="btn btn-primary rounded-1 me-2"></Button>}
                            <Button onClick={handleAdd} type="button" bname="Add Booking" name="add-booking" id="add-booking" className="btn btn-primary rounded-1 me-2"></Button>
                            <BootstrapSelect options={AllColumn} isMultiSelect={true} showTick={true} defaultOptions={defaultColumn}
                                className="edit-column" selectStyle="btn-primary"
                                actionBtnStyle="btn-outline-primary"
                                showSearch={true} showAction={true} placeholder="Edit Column" onChange={handleChange} />
                        </ButtonGroup>
                    </div>
                    <Row className="row-mb">

                        <Col lg={3} style={{paddingTop:"31px"}}>
                            <div className="text-start">
                                <InputGroup>
                                    <Input value={key} type="text" id="search-booking" name="search-booking" className="form-control form-control-sm h-auto" placeholder="Search . . ." onChange={(e: any) => setKey(e.target.value)} />
                                    <Button disabled={key.length < 3} onClick={handleSearch} type="button" bname="Search" name="search-button" id="search-button" className="btn btn-primary btn-sm rounded-1" />
                                </InputGroup>
                                {key.length > 0 && key.length < 3 && <span className="error-msg">Minimum 3 characters required</span>}
                            </div>
                        </Col>
                        <Col lg={4}>
                            <label className="form-label me-1"> Start Date : </label>
                            <DatePicker
                                format="DD-MM-YYYY"
                                value={fromDate}
                                onChange={handleFromDate}
                                render={<InputIcon className="form-control form-control-sm h-auto" />}
                            />
                        </Col>
                        <Col lg={4} className="position-relative">
                            <InputGroup className="align-items-center">
                                <label className="form-label me-1"> End Date : </label>
                                <DatePicker
                                    format="DD-MM-YYYY"
                                    value={toDate}
                                    onChange={handleToDate}
                                    render={<InputIcon className="border-end-0 form-control form-control-sm h-auto" />}
                                    minDate={new Date(fromDate?.split("-").reverse().join("-"))}
                                />
                                <Button onClick={handleSearchByDate} type="button" bname="Go" name="Go-button" id="go-button" className="btn btn-primary btn-sm rounded-1" />
                            </InputGroup>
                            {/* {(fromDate ||
                                toDate ||
                                key ||
                                sportName ||
                                courtName ||
                                bookingType ||
                                bookingStatus ||
                                paymentMode ||
                                paymentStatus ||
                                sorting.column.length) ? (
                                <div
                                    onClick={handleClear}
                                    className="btn btn-link position-absolute top-0"
                                    style={{ cursor: "pointer", left: "90%", paddingTop:'31px' }}
                                >
                                    Clear
                                </div>
                            ) : ""} */}
                        </Col>
                        <Col lg={1} style={{paddingTop:"28px"}}>
                            {(fromDate ||
                                toDate ||
                                key ||
                                sportName ||
                                courtName ||
                                bookingType ||
                                bookingStatus ||
                                paymentMode ||
                                paymentStatus ||
                                sorting.column.length) ? (
                                <div
                                    onClick={handleClear}
                                    className="btn btn-link"
                                    style={{ cursor: "pointer" }}
                                >
                                    Clear
                                </div>
                            ) : ""}
                        </Col>
                    </Row>
                </Card.Body>
                <div className="table-responsive">
                    <Table
                        columns={courtColumns}
                        data={AllBookedCourtsData}
                        HandleShow={handleUserInfo}
                        hideEditAction={true}
                        hideViewAction={false}
                        hideDeleteAction={true}
                        currentPage={currentPage}
                        rowsPerPage={rowsPerPage}
                        totalPage={totalPage}
                        totalRows={totalRows}
                        NextPage={NextPage}
                        PreviousPage={PreviousPage}
                        show={true}
                        isSorting={true}
                        sorting={sorting}
                        setSorting={setSorting}
                        orderColComing={orderColComing}
                    />
                </div>
            </Card>
            <FilterModal show={show} handleClose={handleClose} bookingType={bookingType} bookingStatus={bookingStatus} paidStatus={paymentStatus} paidMode={paymentMode} courtName={courtName} sportName={sportName} setBookingType={setBookingType} setBookingStatus={setBookingStatus} setPaymentStatus={setPaymentStatus} setPaymentMode={setPaymentMode} setSportName={setSportName} setCourtName={setCourtName} handleFilterSubmit={handleFilterSubmit} />
            <DownloadModal downloadModalOpen={downloadModalOpen} setDownloadModalOpen={setDownloadModalOpen} handleDownload={handleDownload} />
        </>
    )
}

export { ListOfCourtsBooking }
